import { buildReportDefaultParams } from "../buildReportDefaultParams";
import { TReportAdminScope } from "../reportCatalog.types";
import { TQuickExportParamsResult } from "./quickExport.types";

interface IBuildQuickExportParamsOptions {
  scope: TReportAdminScope;
  reportId: number;
  code: string;
  isDedicatedRoute: boolean;
}

function withCsvExportType(params: Record<string, unknown>): Record<string, unknown> {
  return { ...params, type: "csv" };
}

export async function buildQuickExportParams(
  options: IBuildQuickExportParamsOptions,
): Promise<TQuickExportParamsResult> {
  const paramsResult = await buildReportDefaultParams(options);

  if (!paramsResult.ok) {
    return paramsResult;
  }

  return {
    ok: true,
    params: withCsvExportType(paramsResult.params),
  };
}
